<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <TeamTable />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import TeamTable from "./components/TeamTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    TeamTable,
    // ProjectsTable,
  },
};
</script>
